import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSpring, animated } from "@react-spring/web";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import CustomLabel from "../../../../../controls/CustomLabel";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { v4 as uuidv4 } from "uuid";
import CustomButton from "../../../../../controls/CustomButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const Fade = React.forwardRef(function Fade(props, ref) {
  const {
    children,
    in: open,
    onClick,
    onEnter,
    onExited,
    ownerState,
    ...other
  } = props || {};
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter(null, true);
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited(null, true);
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {React.cloneElement(children, { onClick })}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element.isRequired,
  in: PropTypes.bool,
  onClick: PropTypes.any,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
  ownerState: PropTypes.any,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  boxShadow: 24,
  padding:"14px",
};
const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

function EditAiQuestion({
  isOpen,
  handleCloseModal,
  editQuestion,
  onEditQuestionSave,
}) {
  const [label, setLabel] = useState("");
  const [isRequired, setIsRequired] = useState(false);

  // Populate initial data on open
  useEffect(() => {
    if (editQuestion) {
      setLabel(editQuestion?.label || "");
      setIsRequired(!!editQuestion?.required);
    }
  }, [editQuestion]);

  const handleSave = () => {
    if (!label.trim()) return;

    const updated = {
      ...editQuestion,
      label: label.trim(),
      required: isRequired,
    };

    onEditQuestionSave(updated);
    handleCloseModal();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleCloseModal}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { TransitionComponent: Fade } }}
    >
      <Fade in={isOpen}>
        <Box sx={style} className="endorsement-box">
          <div className="question_box">
            <div className="template_control">
              <TextField
                className="template_input text_input_field"
                required
                label="Question"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                fullWidth
              />
            </div>
            <div className="switch-content-reports-outer">
              <CustomLabel name="Is control value required?" />
              <AntSwitch
                checked={isRequired}
                onChange={(e) => setIsRequired(e.target.checked)}
              />
            </div>
          </div>
          <div className="q_modal_footer">
            <button className="question_cancel" onClick={handleCloseModal}>
              Cancel
            </button>
            <button className="question_ok" onClick={handleSave}>
              Save
            </button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}
export default EditAiQuestion;
